
const customer = {
  namespaced: true,
  state: {
    customerInfo: {},
  },
  mutations: {
    setCustomerInfo(state, customerInfo) {
      state.customerInfo = customerInfo
    },
  },
  actions: {
    setCustomerInfo({ commit }, customerInfo) {
      commit('setCustomerInfo', customerInfo)
    },
  },
}

export default customer
